import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { toArray } from '../../../../../../services/components';
import Pagination from '../../../Pagination';
import { displayCarouselControls, getAutoScrollInterval, getElementKey, showIndicators } from '../../services';
import { getStepSize } from '../../services/carousel';
import { INDICATORS_POSITION } from '../../services/constants';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps } from '../../types/base';
import './StackSliderCarousel.css';
var defaultProps = _objectSpread(_objectSpread({}, BaseCarouselDefaultProps), {}, {
  displayIndicators: false,
  renderItemContainer: function renderItemContainer(item) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      className: "pagination-element"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      key: getElementKey(item)
    }, item));
  }
});
export default function StackSliderCarousel(_ref) {
  var items = _ref.items,
    size = _ref.size,
    stepSize = _ref.stepSize,
    grouping = _ref.grouping,
    autoScroll = _ref.autoScroll,
    continuous = _ref.continuous,
    displayIndicators = _ref.displayIndicators,
    indicatorsPosition = _ref.indicatorsPosition,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    className = _ref.className,
    renderItemContainer = _ref.renderItemContainer,
    invertedDirection = _ref.invertedDirection,
    animation = _ref.animation,
    displayLeftRightArrows = _ref.displayLeftRightArrows;
  if (_isEmpty(items)) {
    return null;
  }
  var autoScrollInterval = getAutoScrollInterval(autoScroll);
  var pageSize = size;
  var displayControls = displayIndicators ? displayCarouselControls(pageSize, items) : false;
  var finalStepSize = getStepSize(items, pageSize, stepSize, grouping);
  var leftArrow = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "left-arrow"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: invertedDirection ? 'next' : 'previous',
    icon: "chevron up"
  }));
  var rightArrow = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "right-arrow"
  }, /*#__PURE__*/React.createElement(Pagination.Arrow, {
    direction: invertedDirection ? 'previous' : 'next',
    icon: "chevron down"
  }));
  var controls = /*#__PURE__*/React.createElement(Grid.Row, {
    className: "controls"
  }, /*#__PURE__*/React.createElement(Pagination.Indicators, {
    compact: true,
    fitted: true,
    borderless: true,
    vertical: false,
    onlyPageIndicators: true,
    pageIndicatorIcon: pageIndicatorIcon,
    show: showIndicators(pageSize, items, {
      threshold: 6
    })
  }));
  var carousel = /*#__PURE__*/React.createElement(Pagination.Elements, null, function (activeItems) {
    return activeItems.map(renderItemContainer);
  });
  var content = [carousel];
  if (displayLeftRightArrows) {
    content = [leftArrow, carousel, rightArrow];
  }
  if (displayControls) {
    content = indicatorsPosition === INDICATORS_POSITION.top ? [controls].concat(_toConsumableArray(content)) : [].concat(_toConsumableArray(content), [controls]);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel stack-slider-carousel ".concat(className)
  }, /*#__PURE__*/React.createElement(Pagination, {
    pageSize: pageSize,
    items: toArray(items),
    carousel: true,
    stepSize: finalStepSize,
    grouping: grouping,
    continuous: continuous,
    autoScroll: !!autoScroll,
    autoScrollInterval: autoScrollInterval,
    animation: animation
  }, /*#__PURE__*/React.createElement(Grid, null, content)));
}
StackSliderCarousel.defaultProps = defaultProps;